import { BASE_URL } from '.';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;

export const api_getProducts = async (pageNo?: number, pageSize?: number) => {
	const uri = new URL(`${BASE_URL}/products?page=${pageNo}&offset=${pageSize}`);
	try {
		const response = await fetch(uri.toString(), {
			method: 'GET',
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Error fetching products:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getProductsWithFilters = async (name?: string, categoryId?: string) => {
	let uri = `${BASE_URL}/products/filter?`;
	if (name) {
		uri += `name=${encodeURIComponent(name)}`;
	}
	if (categoryId) {
		uri += `categoryId=${encodeURIComponent(categoryId)}`;
	}
	if (categoryId && name) {
		uri += `&categoryId=${encodeURIComponent(categoryId)}`;
	}

	console.log(uri)
	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getProductById = async (id: string, userId: string) => {
	const uri = `${BASE_URL}/products/getById/${id}/${userId}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};

export const api_getProductByCategory = async (
	categoryId: string,
	pageNo: number,
	pageSize: number,
) => {
	try {
		const uri = `${BASE_URL}/products/getByCategory?page=${pageNo}&offset=${pageSize}&categoryId=${categoryId}`;
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		});

		if (!response.ok) {
			throw new Error('Failed to fetch products by category');
		}

		const data = await response.json();
		const isSuccess = response.status >= 200 && response.status < 300;
		return { isSuccess, data: data };
	} catch (error) {
		console.error('Error fetching products by category:', error);
		return { isSuccess: false, message: 'Error fetching products by category' };
	}
};

export const api_getProductByName = async (value: string, pageNo: number, pageSize: number) => {
	const uri = `${BASE_URL}/products/search?page_size=${pageSize}&page_number=${pageNo}&value=${value}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};
export const api_createProduct = async (payload: FormData) => {
	const uri = `${BASE_URL}/products`;
	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: payload,
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the product',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Product created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_editProduct = async (payload: FormData, productId: string) => {
	const uri = `${BASE_URL}/products/${productId}`;
		console.log(JSON.stringify(payload))
	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: payload,
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the product',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Product edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteProduct = async (productId: string) => {
	const uri = `${BASE_URL}/products/${productId}`;
	const response = await fetch(uri, {
		method: 'DELETE',
		headers: {
			authorization: `Bearer ${token}`,
		},
	}).then((res) => res.json());
	return response;
};
